import { useIsMobile } from "../common/utils/hooks/useIsMobile.esm.js";
/* empty css                */
import { jsx } from "react/jsx-runtime";
//#region src/loader/Loader.tsx
function Loader({}) {
	return /* @__PURE__ */ jsx("div", { className: useIsMobile() ? "lds-dual-ring mobile" : "lds-dual-ring" });
}
//#endregion
export { Loader };

//# sourceMappingURL=Loader.esm.js.map